import { HtmlContentProperty } from '../../../interfaces/html-content-property';
import { HtmlContentTarget } from '../../../interfaces/html-content-target';
import { HtmlContentSection } from 'powerschool-design-system/pds-library/src/utils/html-content-sections-engine/html-content-section';

const transparentBackground = 'rgba(0, 0, 0, 0)';

// This property tracks the current background for an element.
//  The background can be found walking up the node tree until you find a non-transparent background.
export const background: HtmlContentProperty = {
  name: 'background',
  value: (target: HtmlContentTarget, style: CSSStyleDeclaration) => {
    let background: string | null = null;

    let element = target.element;
    while (element && background == null && element !== target.container) {
      if (background == null && style.backgroundColor !== transparentBackground) {
        background = style.backgroundColor;
      }

      element = element.parentElement as HTMLElement;
      if (element) {
        style = getComputedStyle(element);
      }
    }

    return background;
  }
};
